function AboutPage() {
  return (
    <>
      <header className="hero legal-hero">
        <div>
          <p className="eyebrow">About Us</p>
          <h1>PartySpark Hub</h1>
          <p className="sub">
            A front-end only, offline-ready party toolbox with entertainment lists, party helpers, a random wheel, truth or
            dare, and a voting wall.
          </p>
          <a className="primary" href="#/">
            Back to Home
          </a>
        </div>
      </header>
      <main className="content">
        <section className="panel legal">
          <div className="panel-head">
            <div>
              <p className="eyebrow">Our Mission</p>
              <h2>Bring friends together, easily and playfully</h2>
            </div>
          </div>
          <div className="legal-block">
            <h3>Product Highlights</h3>
            <ul>
              <li>Front-end only SPA, works offline, no personal data collected.</li>
              <li>Entertainment hub + party assistant + voting wall in one place.</li>
              <li>Supports custom items, deletion, and persistence via localStorage.</li>
              <li>Content-friendly defaults you can edit to fit your event.</li>
            </ul>
          </div>
          <div className="legal-block">
            <h3>Tech Stack</h3>
            <ul>
              <li>React + CSS gradients/glassmorphism</li>
              <li>localStorage persistence</li>
              <li>Hash routing (#/about, #/contact, #/privacy, #/terms, #/legal)</li>
            </ul>
          </div>
        </section>
      </main>
    </>
  );
}

export default AboutPage;

